import { render, staticRenderFns } from "./global-header-layout.vue?vue&type=template&id=8e5d5516&scoped=true"
import script from "./global-header-layout.vue?vue&type=script&lang=js"
export * from "./global-header-layout.vue?vue&type=script&lang=js"
import style0 from "./global-header-layout.vue?vue&type=style&index=0&id=8e5d5516&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5d5516",
  null
  
)

export default component.exports